import { Env } from '../../core/env';
import { isSoloare } from '../../core/models/js_env';
import { CalculateItemSalesPriceWhenQuantityChangeRepository } from '../../core/repositories/calculate_item_sales_price_when_quantity_change_repository';
import { ItemJsEnv } from '../models/item_js_env';
import { GreatValuePriceUtil } from '../util/great_value_price_util';

export class RegularItemPriceAction {
  private static recalculateItemPriceRepository: CalculateItemSalesPriceWhenQuantityChangeRepository;

  static init() {
    this.recalculateItemPriceRepository = new CalculateItemSalesPriceWhenQuantityChangeRepository();
  }

  /// 大業パを持つ定期便商品に対して数量変更を行った場合、販売価格（税込）、販売価格（税抜）を数量変更時商品販売価格再計算結果リストの値に再描画する
  static async changeCartQuantity(model: ItemJsEnv, quantity: number) {
    /// R1では、以下の場合のみ定期便品価格を再取得する：
    /// ログイン時、ソロアリマイレージ企業の場合
    const isSoloareLoginMileage = isSoloare(Env.SITE_TYPE) && model.isLogin && model.isIndividualUnitPriceOnly == false
    if (model.isLargeCommercialPack && isSoloareLoginMileage) {
      const companyId = model.companyId;
      const departmentId = model.departmentId;
      const supplierId = model.supplierId;
      const catalogItemCode = model.catalogItemCode;
      const regularDeliveryCatalogItemCode = model.regularDeliveryCatalogItemCode;

      const result = await this.recalculateItemPriceRepository.getPriceCalculate(
        companyId,
        departmentId,
        supplierId,
        catalogItemCode,
        regularDeliveryCatalogItemCode,
        quantity
      );

      /// カゴエリアの販売価格（税抜）の再描画
      const salesPriceTaxExclude = document.getElementById('regularOrderSalesPriceTaxExclude');
      if (salesPriceTaxExclude !== null && result.salesPriceTaxExclude !== null) {
        salesPriceTaxExclude.textContent = `／ ¥${result.salesPriceTaxExclude.toLocaleString()} （税抜き）`;
      }
      /// カゴエリアの販売価格（税込）の再描画
      const salesPriceTaxInclude = document.getElementById('regularOrderSalesPriceTaxInclude');
      if (salesPriceTaxInclude !== null && result.salesPriceTaxInclude !== null) {
        salesPriceTaxInclude.textContent = `¥${result.salesPriceTaxInclude.toLocaleString()}`;
      }
      // 価格を再算出後、定期便の「お得な価格」を動的に変更する
      GreatValuePriceUtil.reRenderGreatValuePrice();
    }
  }
}
